<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        class="elevation-1"
        item-key="id"
        :footer-props="footerOptions"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-text-field
              v-on:input="debounceInput"
              label="Buscar"
              single-line
              hide-details
            />
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-btn
              v-if="can('crear_distribuidor')"
              color="blue darken-1"
              dark
              class="mb-2"
              @click="newItem()"
            >
              Nuevo Registro
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.activo="{ item }">
          <v-switch
            color="blue darken-1"
            v-model="item.activo"
            @click.prevent="openModalStatus(item)"
          />
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                color="blue darken-1"
                dark
                @click="profile(item)"
                v-on="on"
              >
                mdi-account-search
              </v-icon>
            </template>
            <span>Perfil</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label><br>
          <v-btn
            color="blue darken-1"
            dark
            @click="reset"
          >
            Limpiar búsqueda
          </v-btn>
        </template>
      </v-data-table>
      <delete-dialog
        ref="delete"
        :message.sync="message"
        :type.sync="type"
        :api-u-r-l="apiURL"
      />
      <v-dialog
        v-model="dialogStatus"
        max-width="750"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres cambiar el estado de este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatus = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatus"
              @click.prevent="toggleActive()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogShow"
        max-width="700"
      >
      </v-dialog>
      <v-dialog
        v-model="emailDialogShow"
        max-width="500"
      >
        <v-card>
          <v-card-title class="headline">
            Correo Electrónico del Distribuidor
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="dealerEmail"
              label="Correo Electrónico"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="emailDialogShow = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatus"
              @click.prevent="toggleActive()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import * as _ from 'underscore';
import Form from 'vform';
import DeleteDialog from '~/components/Delete';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('dealers') };
  },
  components: {
    DeleteDialog,
  },
  data: () => ({
    title: 'Distribuidores',
    loading: false,
    options: {},
    search: '',
    items: [],
    totalItems: 0,
    message: '',
    type: '',
    dealerEmail: '',
    dialogStatus: false,
    toggleStatus: false,
    dialogShow: false,
    emailDialogShow: false,
    footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
    items_activo: [
        { value: 0, text: 'INACTIVO' },
        { value: 1, text: 'ACTIVO' },
      ],
    form: new Form({
        razonSocial: '',
        identificacion: '',
        telefono: '',
        email: '',
        direccion: '',
        activo: '',
        created_at: '',
    }),
    headers: [
      {
        text: 'Número de Identificación',
        value: 'identificacion',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Razón Social',
        value: 'razonSocial',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Activo',
        value: 'activo',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
  }),
  computed: {
    apiURL() {
        return '/api/catalogs/dealers';
    },
  },
  mounted() {
    if (!this.can('cambiar_estado_distribuidor')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Activo'), 1);
    }
  },
  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    search: {
      handler() {
        this.options.page = 1;
        this.refreshTable();
      },
      deep: true,
    },
    message: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },
  methods: {
    debounceInput: _.debounce(function d(e) {
      this.search = e;
    }, 500),
    refreshTable() {
      this.getDataFromApi()
      .then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
      });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise(async (resolve) => {
        const {
          sortBy,
          sortDesc,
          page,
          itemsPerPage,
        } = this.options;
        const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
            const data = response.data.items;
            const { total } = response.data;
            return ({ data, total } || []);
        });
        const items = response.data;
        const { total } = response;

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
      &search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    reset() {
      this.search = '';
    },
    profile(item) {
        this.$router.push({ path: `${this.$router.currentRoute.path}/${item.id}` });
    },
    showStock(item) {
      this.$router.push({ path: `${this.$router.currentRoute.path}/${item.id}/licencias` });
    },
    showDevices(item) {
      this.$router.push({ path: `${this.$router.currentRoute.path}/${item.id}/dispositivos` });
    },
    showEnterprises(item) {
      this.$router.push({ path: `${this.$router.currentRoute.path}/${item.id}/empresas` });
    },
    showUserdistributor(item) {
      this.$router.push({ path: `${this.$router.currentRoute.path}/${item.id}/usuarios` });
    },
    newItem() {
      this.$router.push({ path: `${this.$router.currentRoute.path}/agregar` });
    },
    openModalDelete(item) {
      this.$refs.delete.openModal(item);
    },
    editItem(item) {
      const editedItem = { ...item };
      this.$router.push({ path: `${this.$router.currentRoute.path}/editar/${editedItem.id}`, params: { id: editedItem.id } });
    },
    openModalStatus(item) {
      if (!item.activo) {
        this.dialogStatus = true;
        this.item = item;
      }
    },
    toggleActive() {
      this.toggleStatus = true;
      let data = {};
      if (this.dealerEmail) {
        data = { email: this.dealerEmail };
      }
      const url = `${this.apiURL}/${this.item.id}/toggle`;
      window.axios.post(url, data)
        .then((response) => {
          this.toggleStatus = false;
          if (response.data.type === 'success') {
            this.action = 'toggleStatus';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatus = false;
            this.emailDialogShow = false;
            this.dealerEmail = '';
            this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
          } else {
            this.dialogStatus = false;
            this.emailDialogShow = true;
          }
        });
    },
    openModalShow(item) {
        this.dialogShow = true;
        if (item.cat_corregimiento_id) {
            const url = `/api/showCorregimiento/${item.cat_corregimiento_id}`;
            window.axios.get(url)
            .then((response) => {
              Object.assign(this.form, item);
              this.form.cat_corregimiento_name = response.data.name;
          });
        }
      },
  },
};
</script>
